module.exports = __webpack_public_path__ + "static/media/KyungHeeUni.f68bb6cf.png";